import React, { type ReactNode, useEffect, useMemo, useRef } from 'react';
// @ts-expect-error - TS2724 - '"redux"' has no exported member named 'CombinedReducer'. Did you mean 'combineReducers'? Caused by 3rd party lib
import type { CombinedReducer } from 'redux';
import type { Epic } from 'redux-observable';
import initiateStore from '@atlassian/jira-common-tangerine/src/state/initiate';
import { Provider as ReduxProvider } from '@atlassian/jira-react-redux';

import type { BaseState, Action } from '../../../model/types';

type Props = {
	storeName: string;
	initialState: BaseState;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	initialActions?: (() => any)[];
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	rootReducer: CombinedReducer<any, Action>;

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	rootEpic: Epic<any, any>;
	children: ReactNode;
};

const ReduxConnector = ({
	storeName,
	initialState,
	initialActions,
	rootReducer,
	rootEpic,
	children,
}: Props) => {
	// Guarantees store is created only once for component's lifespan
	const createStoreRef = useRef(() =>
		initiateStore({ appName: storeName, initialState, rootReducer, rootEpic }),
	);
	// Guarantees same store is used throughout component's lifespan
	// go/jfe-eslint
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const store = useMemo(createStoreRef.current, []);
	// Guarantees initial actions only get run once even if prop changes
	const initialActionsRef = useRef(initialActions);

	useEffect(() => {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		initialActionsRef.current?.forEach((action: () => any) => {
			store.dispatch(action());
		});
	}, [store]);

	return (
		// ReduxProvider provides store only to first child. Using fragment so if multiple
		// children are given, all will get store context. Common case for this is when
		// FlagsDispatcher and app need to share the same store
		<ReduxProvider store={store}>
			<>{children}</>
		</ReduxProvider>
	);
};

export default ReduxConnector;
